export interface EmailFilterState {
  status: string
  fromEmail: string
  toEmail: string
  clientOrgId: string
}

export const DEFAULT_EMAIL_FILTERS: EmailFilterState = {
  status: '',
  fromEmail: '',
  toEmail: '',
  clientOrgId: '',
}

export function countActiveEmailFilters(filters: EmailFilterState): number {
  let count = 0
  if (filters.status) count++
  if (filters.fromEmail.trim()) count++
  if (filters.toEmail.trim()) count++
  if (filters.clientOrgId) count++
  return count
}

export const EMAIL_STATUS_OPTIONS = [
  { id: 'processed', label: 'Processed' },
  { id: 'failed', label: 'Failed' },
  { id: 'skipped', label: 'Skipped' },
  { id: 'pending', label: 'Pending' },
] as const
